import React, { useState, useCallback, Fragment, useContext, useEffect, useRef } from 'react';

import { isValidMobilePhoneNumber } from 'app/home/general-components/NumberInputHelper';
import { LocalizationContext, useLocalizedStrings } from 'app/localization/Context';
import PhoneNumberInput from 'app/home/general-components/PhoneNumberInput/PhoneNumberInput';

import InputCode from 'app/home/general-components/InputCode/InputCode';
import { stringFormat } from 'app/model/BindData';

import { ReactComponent as IconPhone } from 'images/general/call-white.svg';
import { ReactComponent as IconHome } from 'images/homeTab/devices.svg';
import { ReactComponent as IconNext } from 'images/general/next-black.svg';
import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconRefresh } from 'images/general/refresh.svg';

import packageJson from '../../../../../package.json';

import './GetNumber.scss'

// update GetNumberToAddUser if needed

export default function GetNumber({ setPhoneNumber, switchToHubIfExists, canDismiss, dismiss, homeType }) {
    const s = useLocalizedStrings();

    const isStaging = (packageJson.serverName === "staging");

    const [_countryCode, _setCountryCode] = useState('');
    const [_phoneNumber, _setPhoneNumber] = useState('');

    const nextToSimClick = useCallback(() => {
        const num = "+000657166232"; // staging
        const switched = switchToHubIfExists(num);
        if (!switched) {
            setPhoneNumber(num);
        }
    }, [setPhoneNumber, switchToHubIfExists]);
    const nextClick = useCallback(() => {
        if (isValidMobilePhoneNumber(_countryCode, _phoneNumber)) {
            const num = "+" + _countryCode + _phoneNumber;
            if (switchToHubIfExists !== undefined) {
                const switched = switchToHubIfExists(num);
                if (!switched) {
                    setPhoneNumber(num);
                }
            } else { // solo (it's user's phone number)
                setPhoneNumber(num);
            }
        }
    }, [setPhoneNumber, _countryCode, _phoneNumber, switchToHubIfExists]);

    const onPhoneNumberChange = useCallback((countryCode, phoneNumber) => {
        _setCountryCode(countryCode);
        _setPhoneNumber(phoneNumber);
    }, []);

    const isHub = (homeType === "hub");

    return (
        <div className="register-home-get-number">
            {
                canDismiss ? <Fragment>
                    <IconX className="x-icon" />
                    <div className="x-button" onClick={dismiss} />
                </Fragment> : null
            }

            {
                isHub ? <Fragment>
                    <IconHome className="home-icon" />
                    <div className="welcome">{s.connectToHub}</div>
                    <div className="intro">{s.connectToHubInfo}</div>
                    <div className="input-label">{s.gatewayNumber}</div>
                </Fragment> : <Fragment>
                    <IconPhone className="home-icon" />
                    <div className="welcome">{s.connectToSolo}</div>
                    <div className="intro">{s.connectToSoloInfo}</div>
                    <div className="input-label">{s.phoneNumber}</div>
                </Fragment>
            }
            <PhoneNumberInput
                onPhoneNumberChange={onPhoneNumberChange}
            />
            <div />
            {
                (isHub && isStaging) ?
                    (
                        <div className="next-to-sim-button" onClick={nextToSimClick}>
                            <div>{s.useSimulatedGateway}</div> <IconNext className="icon" />
                        </div>
                    ) : null
            }
            {!isValidMobilePhoneNumber(_countryCode, _phoneNumber) ? <div className="error-label">{s.youMustEnterAPN}</div> : null}
            <div className="next-button" onClick={nextClick} style={{ opacity: isValidMobilePhoneNumber(_countryCode, _phoneNumber) ? 1 : 0.3 }}>
                <div>{s.next}</div> <IconNext className="icon" />
            </div>
        </div>
    )
}

export function AskVerificationCode({ canDismiss, dismiss, phoneNumber, checkCode, resend, thereWasErrorForCode }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const [input, setInput] = useState('');

    const doneClicked = useCallback(() => {
        if (input.length === 5)
            checkCode(input);
    }, [checkCode, input]);

    const [resendNumber, setResendNumber] = useState(0);
    const [waitTimer, setWaitTimer] = useState(60);
    let waitIntervalTimer = useRef(undefined);

    useEffect(() => {
        let i = setInterval(() => {
            setWaitTimer(t => ((t > 0) ? (t - 1) : 0));
        }, 1000);
        waitIntervalTimer.current = i;
        return () => { clearInterval(i) };
    }, [resendNumber]);
    useEffect(() => {
        if (waitTimer <= 0)
            clearInterval(waitIntervalTimer.current);
    }, [waitTimer]);

    const resendClicked = useCallback(() => {
        if (resendNumber < 2) { // can resend two times
            setWaitTimer(60);
            setResendNumber(resendNumber + 1)
            resend();
        }
    }, [resendNumber, resend]);

    return (
        <div className="register-home-get-number">
            <IconX className="x-icon" />
            <div className="x-button" onClick={dismiss} />

            <IconPhone className="home-icon" />
            <div className="welcome">{s.verificationCode}</div>
            <div className="intro">{stringFormat(s.verificationCodeInfoF, l.localizeAndFixSignedNumbers(phoneNumber))}</div>

            <InputCode keyPrefix="solo-input-code" marginTop={72} numberOfItems={5} codeVlaueCallback={setInput} />

            {(thereWasErrorForCode) ?
                <div className="wrong-label">{s.codeWasWrong}</div>
                : <div />}

            <div />
            { // resend section
                (resendNumber >= 2) ?
                    null : (
                        // <div className="resend-label">{s.resendCodeLimit}</div> : (
                        (waitTimer === 0) ? (
                            <div className="resend-button" onClick={resendClicked}>
                                <div>{s.resendCode}</div> <IconRefresh className="icon" />
                            </div>
                        ) :
                            <div className="resend-label">{stringFormat(s.resendCodeInfoF, l.localizeNumber(waitTimer))}</div>
                    )
            }
            {!(input.length === 5) ? <div className="error-label-non-absolute">{s.youMustEnterTheCode}</div> : null}
            <div className="next-button" onClick={doneClicked} style={{ opacity: (input.length === 5) ? 1 : 0.3 }}>
                <div>{s.next}</div> <IconNext className="icon" />
            </div>
        </div>
    )
}
